module.exports = __webpack_public_path__ + "static/media/BS_O_Embroidery_Bicocca_Bordeaux_White.7e4fbe30.png";